
























































import { Component, Emit, Vue } from 'vue-property-decorator'
import { vxm } from '@/state/index'
import { auth } from '@/auth/auth'

@Component
export default class AppBar extends Vue {
  private authUser: unknown = vxm.authUser

  public logOut(): void {
    auth.signOut()
  }

  @Emit('showNav')
  showNav() {
    //
  }
}

